const Component = {
  render: function render() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c('div', [
      _c('h1', { staticClass: 'uk-h1 tm-heading-fragment' }, [
        _vm._v('Integration')
      ]),
      _c('p', { staticClass: 'uk-text-lead' }, [
        _vm._v('Integrate Vuikit into your project.')
      ]),
      _vm._v(' '),
      _vm._m(0),
      _vm._v(' '),
      _c('hr', { staticClass: 'uk-margin-large' }),
      _vm._m(1),
      _vm._m(2),
      _vm._v(' '),
      _vm._m(3),
      _vm._m(4),
      _vm._m(5),
      _c('hr', { staticClass: 'uk-margin-large' }),
      _vm._m(6),
      _c(
        'p',
        [
          _vm._v(
            'If you are including Vue via a script tag without a build tool, first '
          ),
          _c(
            'router-link',
            { staticClass: 'tm-internal-link', attrs: { to: '/download' } },
            [_vm._v('download')]
          ),
          _vm._v(
            ' the Vuikit main package. The Zip file contains the compiled CSS and JavaScript files, which is everything you need to get started. '
          )
        ],
        1
      ),
      _vm._v(' '),
      _vm._m(7),
      _vm._m(8),
      _vm._m(9),
      _c('p', [
        _vm._v(
          "Add the compiled and minified CSS and JavaScript to the header of your HTML5 document for production. Also include the Vuikit Icon library if required. For a basic setup, that's it!"
        )
      ]),
      _vm._v(' '),
      _vm._m(10)
    ])
  },
  staticRenderFns: [
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c('p', [
        _vm._v(
          "Assuming you are already familiar with Vue installation, here are different ways to integrate Vuikit with Vue. If you're not familiar with Vue or need a refresher, please check the "
        ),
        _c(
          'a',
          {
            attrs: {
              href: 'https://vuejs.org/v2/guide/installation.html',
              target: '_blank'
            }
          },
          [_vm._v('Vue documentation')]
        ),
        _vm._v('.')
      ])
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c(
        'h2',
        {
          staticClass: 'uk-h2 tm-heading-fragment',
          attrs: { id: 'with-build-tools' }
        },
        [
          _c('a', { attrs: { href: '#with-build-tools' } }, [
            _vm._v('With Build Tools')
          ])
        ]
      )
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c('p', [
        _vm._v('When using a build tool like Webpack or Browserify, use '),
        _c(
          'a',
          { attrs: { href: 'https://www.npmjs.com', target: '_blank' } },
          [_vm._v('Npm')]
        ),
        _vm._v(' or '),
        _c('a', { attrs: { href: 'https://yarnpkg.com', target: '_blank' } }, [
          _vm._v('Yarn')
        ]),
        _vm._v(
          ' to install the project dependencies. This also provides the pre-built source files. Because of its ease of use and flexibility, this is the recommended way for a typical web project.'
        )
      ])
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c('div', { staticClass: 'uk-margin-medium' }, [
        _c('pre', [
          _c('code', { staticClass: 'lang-bash hljs' }, [
            _vm._v(
              'npm install vue\nnpm install vuikit\nnpm install @vuikit/icons\nnpm install @vuikit/theme'
            )
          ])
        ])
      ])
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c('div', { staticClass: 'uk-margin-medium' }, [
        _c('pre', [
          _c('code', { staticClass: 'lang-js hljs' }, [
            _c('span', { staticClass: 'hljs-comment' }, [
              _vm._v('// later in your source files')
            ]),
            _vm._v('\n'),
            _c('span', { staticClass: 'hljs-keyword' }, [_vm._v('import')]),
            _vm._v(' Vue '),
            _c('span', { staticClass: 'hljs-keyword' }, [_vm._v('from')]),
            _vm._v(' '),
            _c('span', { staticClass: 'hljs-string' }, [_vm._v("'vue'")]),
            _vm._v('\n'),
            _c('span', { staticClass: 'hljs-keyword' }, [_vm._v('import')]),
            _vm._v(' Vuikit '),
            _c('span', { staticClass: 'hljs-keyword' }, [_vm._v('from')]),
            _vm._v(' '),
            _c('span', { staticClass: 'hljs-string' }, [_vm._v("'vuikit'")]),
            _vm._v('\n'),
            _c('span', { staticClass: 'hljs-keyword' }, [_vm._v('import')]),
            _vm._v(' VuikitIcons '),
            _c('span', { staticClass: 'hljs-keyword' }, [_vm._v('from')]),
            _vm._v(' '),
            _c('span', { staticClass: 'hljs-string' }, [
              _vm._v("'@vuikit/icons'")
            ]),
            _vm._v('\n\n'),
            _c('span', { staticClass: 'hljs-keyword' }, [_vm._v('import')]),
            _vm._v(' '),
            _c('span', { staticClass: 'hljs-string' }, [
              _vm._v("'@vuikit/theme'")
            ]),
            _vm._v('\n\nVue.use(Vuikit)\nVue.use(VuikitIcons)')
          ])
        ])
      ])
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c('div', { staticClass: 'uk-margin-medium' }, [
        _c('pre', [
          _c('code', { staticClass: 'lang-js hljs' }, [
            _c('span', { staticClass: 'hljs-comment' }, [
              _vm._v('// You may as well lower the bundle size by')
            ]),
            _vm._v('\n'),
            _c('span', { staticClass: 'hljs-comment' }, [
              _vm._v('// cherry-picking only the resources you need')
            ]),
            _vm._v('\n'),
            _c('span', { staticClass: 'hljs-keyword' }, [_vm._v('import')]),
            _vm._v(' Vue '),
            _c('span', { staticClass: 'hljs-keyword' }, [_vm._v('from')]),
            _vm._v(' '),
            _c('span', { staticClass: 'hljs-string' }, [_vm._v("'vue'")]),
            _vm._v('\n'),
            _c('span', { staticClass: 'hljs-keyword' }, [_vm._v('import')]),
            _vm._v(' { Card } '),
            _c('span', { staticClass: 'hljs-keyword' }, [_vm._v('from')]),
            _vm._v(' '),
            _c('span', { staticClass: 'hljs-string' }, [
              _vm._v("'vuikit/lib/card'")
            ]),
            _vm._v('\n'),
            _c('span', { staticClass: 'hljs-keyword' }, [_vm._v('import')]),
            _vm._v(' { Button, ButtonLink } '),
            _c('span', { staticClass: 'hljs-keyword' }, [_vm._v('from')]),
            _vm._v(' '),
            _c('span', { staticClass: 'hljs-string' }, [
              _vm._v("'vuikit/lib/button'")
            ]),
            _vm._v('\n\n'),
            _c('span', { staticClass: 'hljs-comment' }, [
              _vm._v('// register globally')
            ]),
            _vm._v('\nVue.component('),
            _c('span', { staticClass: 'hljs-string' }, [_vm._v("'Card'")]),
            _vm._v(', Card)\n\n'),
            _c('span', { staticClass: 'hljs-keyword' }, [_vm._v('export')]),
            _vm._v(' '),
            _c('span', { staticClass: 'hljs-keyword' }, [_vm._v('default')]),
            _vm._v(' {\n  '),
            _c('span', { staticClass: 'hljs-comment' }, [
              _vm._v('// or locally')
            ]),
            _vm._v('\n  components: {\n    '),
            _c('span', { staticClass: 'hljs-attr' }, [_vm._v('VkButton')]),
            _vm._v(': Button,\n    '),
            _c('span', { staticClass: 'hljs-attr' }, [_vm._v('VkButtonLink')]),
            _vm._v(': ButtonLink\n  },\n  '),
            _c('span', { staticClass: 'hljs-attr' }, [_vm._v('template')]),
            _vm._v(': '),
            _c('span', { staticClass: 'hljs-string' }, [
              _vm._v(
                '`<vk-card>\n    <vk-button>...</vk-button>\n  </vk-card>`'
              )
            ]),
            _vm._v('\n}')
          ])
        ])
      ])
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c(
        'h2',
        {
          staticClass: 'uk-h2 tm-heading-fragment',
          attrs: { id: 'without-build-tools' }
        },
        [
          _c('a', { attrs: { href: '#without-build-tools' } }, [
            _vm._v('Without Build Tools')
          ])
        ]
      )
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c(
        'h3',
        {
          staticClass: 'uk-h3 tm-heading-fragment',
          attrs: { id: 'package-contents' }
        },
        [
          _c('a', { attrs: { href: '#package-contents' } }, [
            _vm._v('Package contents')
          ])
        ]
      )
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c('div', { staticClass: 'uk-overflow-auto' }, [
        _c('table', { staticClass: 'uk-table uk-table-divider' }, [
          _c('thead', [
            _c('tr', [
              _c('th', { staticStyle: { 'text-align': 'left' } }, [
                _vm._v('Folder')
              ]),
              _vm._v(' '),
              _c('th', { staticStyle: { 'text-align': 'left' } }, [
                _vm._v('Description')
              ])
            ])
          ]),
          _vm._v(' '),
          _c('tbody', [
            _c('tr', [
              _c('td', { staticStyle: { 'text-align': 'left' } }, [
                _c('code', [_vm._v('/css')])
              ]),
              _vm._v(' '),
              _c('td', { staticStyle: { 'text-align': 'left' } }, [
                _vm._v('Contains the Vuikit CSS.')
              ])
            ]),
            _vm._v(' '),
            _c('tr', [
              _c('td', { staticStyle: { 'text-align': 'left' } }, [
                _c('code', [_vm._v('/js')])
              ]),
              _vm._v(' '),
              _c('td', { staticStyle: { 'text-align': 'left' } }, [
                _vm._v(
                  'Contains the Vuikit JavaScript and the Icon Library JavaScript.'
                )
              ])
            ])
          ])
        ])
      ])
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c(
        'h3',
        {
          staticClass: 'uk-h3 tm-heading-fragment',
          attrs: { id: 'html-markup' }
        },
        [_c('a', { attrs: { href: '#html-markup' } }, [_vm._v('HTML markup')])]
      )
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c('div', { staticClass: 'uk-margin-medium' }, [
        _c('pre', [
          _c('code', { staticClass: 'lang-html hljs' }, [
            _c('span', { staticClass: 'hljs-meta' }, [
              _vm._v('<!DOCTYPE html>')
            ]),
            _vm._v('\n'),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('<'),
              _c('span', { staticClass: 'hljs-name' }, [_vm._v('html')]),
              _vm._v('>')
            ]),
            _vm._v('\n  '),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('<'),
              _c('span', { staticClass: 'hljs-name' }, [_vm._v('head')]),
              _vm._v('>')
            ]),
            _vm._v('\n    '),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('<'),
              _c('span', { staticClass: 'hljs-name' }, [_vm._v('title')]),
              _vm._v('>')
            ]),
            _vm._v('Title'),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('</'),
              _c('span', { staticClass: 'hljs-name' }, [_vm._v('title')]),
              _vm._v('>')
            ]),
            _vm._v('\n    '),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('<'),
              _c('span', { staticClass: 'hljs-name' }, [_vm._v('meta')]),
              _vm._v(' '),
              _c('span', { staticClass: 'hljs-attr' }, [_vm._v('charset')]),
              _vm._v('='),
              _c('span', { staticClass: 'hljs-string' }, [_vm._v('"utf-8"')]),
              _vm._v('>')
            ]),
            _vm._v('\n    '),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('<'),
              _c('span', { staticClass: 'hljs-name' }, [_vm._v('meta')]),
              _vm._v(' '),
              _c('span', { staticClass: 'hljs-attr' }, [_vm._v('name')]),
              _vm._v('='),
              _c('span', { staticClass: 'hljs-string' }, [
                _vm._v('"viewport"')
              ]),
              _vm._v(' '),
              _c('span', { staticClass: 'hljs-attr' }, [_vm._v('content')]),
              _vm._v('='),
              _c('span', { staticClass: 'hljs-string' }, [
                _vm._v('"width=device-width, initial-scale=1"')
              ]),
              _vm._v('>')
            ]),
            _vm._v('\n    '),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('<'),
              _c('span', { staticClass: 'hljs-name' }, [_vm._v('link')]),
              _vm._v(' '),
              _c('span', { staticClass: 'hljs-attr' }, [_vm._v('rel')]),
              _vm._v('='),
              _c('span', { staticClass: 'hljs-string' }, [
                _vm._v('"stylesheet"')
              ]),
              _vm._v(' '),
              _c('span', { staticClass: 'hljs-attr' }, [_vm._v('href')]),
              _vm._v('='),
              _c('span', { staticClass: 'hljs-string' }, [
                _vm._v('"css/vuikit.min.css"')
              ]),
              _vm._v(' />')
            ]),
            _vm._v('\n    '),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('<'),
              _c('span', { staticClass: 'hljs-name' }, [_vm._v('script')]),
              _vm._v(' '),
              _c('span', { staticClass: 'hljs-attr' }, [_vm._v('src')]),
              _vm._v('='),
              _c('span', { staticClass: 'hljs-string' }, [
                _vm._v('"js/vue.min.js"')
              ]),
              _vm._v('>')
            ]),
            _c('span', { staticClass: 'undefined' }),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('</'),
              _c('span', { staticClass: 'hljs-name' }, [_vm._v('script')]),
              _vm._v('>')
            ]),
            _vm._v('\n    '),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('<'),
              _c('span', { staticClass: 'hljs-name' }, [_vm._v('script')]),
              _vm._v(' '),
              _c('span', { staticClass: 'hljs-attr' }, [_vm._v('src')]),
              _vm._v('='),
              _c('span', { staticClass: 'hljs-string' }, [
                _vm._v('"js/vuikit.min.js"')
              ]),
              _vm._v('>')
            ]),
            _c('span', { staticClass: 'undefined' }),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('</'),
              _c('span', { staticClass: 'hljs-name' }, [_vm._v('script')]),
              _vm._v('>')
            ]),
            _vm._v('\n    '),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('<'),
              _c('span', { staticClass: 'hljs-name' }, [_vm._v('script')]),
              _vm._v(' '),
              _c('span', { staticClass: 'hljs-attr' }, [_vm._v('src')]),
              _vm._v('='),
              _c('span', { staticClass: 'hljs-string' }, [
                _vm._v('"js/vuikit-icons.min.js"')
              ]),
              _vm._v('>')
            ]),
            _c('span', { staticClass: 'undefined' }),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('</'),
              _c('span', { staticClass: 'hljs-name' }, [_vm._v('script')]),
              _vm._v('>')
            ]),
            _vm._v('\n  '),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('</'),
              _c('span', { staticClass: 'hljs-name' }, [_vm._v('head')]),
              _vm._v('>')
            ]),
            _vm._v('\n  '),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('<'),
              _c('span', { staticClass: 'hljs-name' }, [_vm._v('body')]),
              _vm._v('>')
            ]),
            _vm._v('\n    '),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('<'),
              _c('span', { staticClass: 'hljs-name' }, [_vm._v('div')]),
              _vm._v(' '),
              _c('span', { staticClass: 'hljs-attr' }, [_vm._v('id')]),
              _vm._v('='),
              _c('span', { staticClass: 'hljs-string' }, [_vm._v('"app"')]),
              _vm._v('>')
            ]),
            _vm._v('\n      '),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('<'),
              _c('span', { staticClass: 'hljs-name' }, [_vm._v('vk-card')]),
              _vm._v('>')
            ]),
            _vm._v('\n        '),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('<'),
              _c('span', { staticClass: 'hljs-name' }, [_vm._v('vk-button')]),
              _vm._v('>')
            ]),
            _vm._v('...'),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('</'),
              _c('span', { staticClass: 'hljs-name' }, [_vm._v('vk-button')]),
              _vm._v('>')
            ]),
            _vm._v('\n      '),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('</'),
              _c('span', { staticClass: 'hljs-name' }, [_vm._v('vk-card')]),
              _vm._v('>')
            ]),
            _vm._v('\n    '),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('</'),
              _c('span', { staticClass: 'hljs-name' }, [_vm._v('div')]),
              _vm._v('>')
            ]),
            _vm._v('\n    '),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('<'),
              _c('span', { staticClass: 'hljs-name' }, [_vm._v('script')]),
              _vm._v('>')
            ]),
            _c('span', { staticClass: 'actionscript' }, [
              _vm._v('\n      '),
              _c('span', { staticClass: 'hljs-keyword' }, [_vm._v('new')]),
              _vm._v(' Vue({ el: '),
              _c('span', { staticClass: 'hljs-string' }, [_vm._v("'#app'")]),
              _vm._v(' })\n    ')
            ]),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('</'),
              _c('span', { staticClass: 'hljs-name' }, [_vm._v('script')]),
              _vm._v('>')
            ]),
            _vm._v('\n  '),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('</'),
              _c('span', { staticClass: 'hljs-name' }, [_vm._v('body')]),
              _vm._v('>')
            ]),
            _vm._v('\n'),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('</'),
              _c('span', { staticClass: 'hljs-name' }, [_vm._v('html')]),
              _vm._v('>')
            ])
          ])
        ])
      ])
    }
  ],
  data: function() {
    return {}
  },
  scrollToTop: true,
  sections: [
    { id: 'with-build-tools', title: 'With Build Tools' },
    { id: 'without-build-tools', title: 'Without Build Tools' }
  ],
  components: {}
}


export default Component
